import { Component, OnInit } from '@angular/core';
import { MetaService } from '@ngx-meta/core';
import { CanonicalService } from '../../shared/services/canonical.service';
import { RACKEO_SITE } from '../../shared/rackeo-site';

@Component({
  selector: 'app-empresa-formas-pago',
  templateUrl: './empresa-formas-pago.component.html',
  styleUrls: ['./empresa-formas-pago.component.scss']
})
export class EmpresaFormasPagoComponent implements OnInit {
  private readonly imgBase = 'assets/images/rackeo/empresa/formas-pago';
  readonly bannerSrc = `${this.imgBase}/pago-master-banner.png`;
  readonly webpaySrc = `${this.imgBase}/logo-webpay-cl.png`;
  readonly linkifySrc = `${this.imgBase}/linkify.png`;

  constructor(
    private readonly meta: MetaService,
    private readonly canonical: CanonicalService
  ) {}

  ngOnInit(): void {
    this.meta.setTitle('Empresa | Formas de pago | Rackeo');
    this.meta.setTag('description', 'Formas de pago Rackeo: transferencia bancaria a través de Linkify.');
    this.meta.setTag('og:type', 'website');
    this.meta.setTag('og:image:type', 'image/png');
    this.meta.setTag('og:image', RACKEO_SITE.ogImageUrl);
    this.meta.setTag('og:image:width', '1200');
    this.meta.setTag('og:image:height', '1200');
    this.meta.setTag('og:image:alt', 'Empresa | Formas de pago | Rackeo');
    this.meta.setTag('og:locale', RACKEO_SITE.ogLocale);
    this.canonical.set('/empresa/formas-pago');
  }
}
